module.exports = __webpack_public_path__ + "img/Etica.e59be389.png";